import { Marker } from "leaflet";
import { LocationType } from "../../../models";
import { LayerComponent, LayerType } from "./LayerComponent";

export class PlaceComponents {
    private _layers: LayerComponent[] = [];
    keep = true;

    addLayer(layer: LayerComponent): LayerComponent {
        console.assert(!this.hasLayer(layer.id), "Layers must be unique");
        this._layers.push(layer);
        layer.attachLayer();
        return layer;
    }

    getLayer(id: string): LayerComponent | undefined {
        const layers = this._layers.filter((x) => x.id === id);

        console.assert(layers.length < 2, "Layers must be unique");

        return layers.length === 0 ? undefined : layers[0];
    }

    getLayersOfType(types: LayerType[]): LayerComponent[] {
        return this._layers.filter((x) => types.includes(x.type));
    }

    hasLayer(id: string): boolean {
        return !!this.getLayer(id);
    }

    removeLayer(id: string): void {
        const layer = this.getLayer(id);
        if (layer) {
            layer.detachLayer();
            this._layers = this._layers.filter((x) => x.id !== id);
        }
    }

    clearAllLayers(): void {
        this._layers.forEach((x) => x.detachLayer());
        this._layers = [];
    }

    marker: Marker | undefined;
    markerType: LocationType | undefined;
    markerName: string | undefined;
}
